export default {
  "create": "បង្កើតថ្មី",
  "save": "រក្សាទុក",
  "saveAndNew": "រក្សាទុក & បង្កើតថ្មី",
  "discard": "ត្រលប់",
  "additionalInfo": "ពត៍មានបន្ថែម",
  "loading": "កំពុងដំណេីរការ...",
};
